module.exports = __webpack_public_path__ + "img/541.9a822b9a.png";